import {
  GOLD,
  PUBLIC_CUP_SIZES,
  championGoldFrom,
  leagueOf,
  maxReward,
  placeRewardFrom,
} from '@penalty-cup/shared';
import { useState } from 'react';
import { Avatar } from '../components/Avatar.js';
import { PendingInvite } from '../components/PendingInvite.js';
import { TicketsBar } from '../components/TicketsBar.js';
import { useApp } from '../store.js';

/** Главный: профиль и баланс, плитки режимов 2×2, игра с друзьями. Навигация — внизу (BottomNav). */
export function Home() {
  const me = useApp((s) => s.me);
  const settings = useApp((s) => s.settings);
  const play = useApp((s) => s.play);
  const joining = useApp((s) => s.joining);
  const setView = useApp((s) => s.setView);
  const notice = useApp((s) => s.notice);
  const soundOn = useApp((s) => s.soundOn);
  const toggleSound = useApp((s) => s.toggleSound);
  const createDuel = useApp((s) => s.createDuel);
  const quick = useApp((s) => s.playQuick);
  const createFriendsCup = useApp((s) => s.createFriendsCup);
  const [cupSize, setCupSize] = useState(false);
  if (!me) return null;
  const league = leagueOf(me.rating);

  return (
    <main className="screen home screen--nav">
      <button
        type="button"
        className="sound-toggle"
        onClick={toggleSound}
        aria-label={soundOn ? 'Выключить звук' : 'Включить звук'}
        aria-pressed={soundOn}
      >
        {soundOn ? '🔊' : '🔇'}
      </button>
      <span className="home__coins" aria-label="Серебро">
        🪙 {me.coins}
      </span>
      <button type="button" className="home__profile" onClick={() => setView('profile')} aria-label="Профиль">
        <Avatar me={me} />
        <span className="home__who">
          <span className="home__name">{me.teamName ?? me.firstName}</span>
          <span className="home__league" style={{ color: league.league.color }}>
            Лига {league.league.name} · {me.rating}
            {me.stats.currentWinStreak >= 2 && (
              <span className="home__streak"> · 🔥 {me.stats.currentWinStreak}</span>
            )}
          </span>
        </span>
      </button>
      <div className="league-bar" aria-label="Прогресс лиги">
        <span
          className="league-bar__fill"
          style={{ width: `${league.progress * 100}%`, background: league.league.color }}
        />
        <span className="league-bar__text">
          {league.next ? `До лиги ${league.next.name} — ${league.toNext}` : 'Высшая лига'}
        </span>
      </div>
      <div className="balance">
        <button
          type="button"
          className="chip chip--small balance__gold"
          onClick={() => setView('exchange')}
          aria-label="Gold и обмен"
        >
          🟡 {me.gold.claimable + me.gold.bonus}
        </button>
        <TicketsBar />
      </div>
      {notice && (
        <p className="field__hint field__hint--error" role="alert">
          {notice}
        </p>
      )}
      <PendingInvite />
      <div className="tiles">
        {PUBLIC_CUP_SIZES.map((size) => (
          <button
            key={size}
            type="button"
            className="tile tile--cup"
            onClick={() => void play(size)}
            disabled={joining}
            aria-label={`Турнир на ${size}`}
          >
            <span className="tile__icon" aria-hidden="true">
              🏆
            </span>
            <b className="tile__title">Турнир {size}</b>
            <span className="tile__meta">
              до {settings ? placeRewardFrom(settings, size, null) : maxReward(size)} 🪙 +{' '}
              {settings ? championGoldFrom(settings, size) : GOLD.champion[size]} 🟡
            </span>
            <span className="tile__meta">🎟 1</span>
          </button>
        ))}
        <button
          type="button"
          className="tile"
          onClick={() => void quick()}
          disabled={joining}
          aria-label="1 на 1"
        >
          <span className="tile__icon" aria-hidden="true">
            ⚡
          </span>
          <b className="tile__title">1 на 1</b>
          <span className="tile__meta">без билета</span>
        </button>
        <button
          type="button"
          className="tile"
          onClick={() => setView('training')}
          aria-label="Training Center"
        >
          <span className="tile__icon" aria-hidden="true">
            🏋️
          </span>
          <b className="tile__title">Training</b>
          <span className="tile__meta">+ серебро</span>
        </button>
      </div>
      <div className="home__friends">
        {cupSize ? (
          <>
            <span className="home__friends-label">Кубок с друзьями:</span>
            <button
              type="button"
              className="chip"
              onClick={() => void createFriendsCup(4)}
              disabled={joining}
            >
              👥 На 4
            </button>
            <button
              type="button"
              className="chip"
              onClick={() => void createFriendsCup(8)}
              disabled={joining}
            >
              👥 На 8
            </button>
          </>
        ) : (
          <>
            <button type="button" className="chip" onClick={() => void createDuel()} disabled={joining}>
              ⚔️ Вызвать друга
            </button>
            <button type="button" className="chip" onClick={() => setCupSize(true)} disabled={joining}>
              👥 Кубок друзей
            </button>
          </>
        )}
      </div>
    </main>
  );
}
